import { createAction } from '@reduxjs/toolkit';

export const fetchProposalsList = createAction('proposals/proposalsList');
export const fetchSentProposalsByLimit = createAction('proposals/sentProposalsByLimit');
export const fetchProposalsByType = createAction('proposals/proposalsByType');
export const fetchProposalsListWidgets = createAction('proposals/proposalsListWidgets')
export const fetchShortProposals = createAction('proposals/fetchShortProposals')
export const fetchAppraisalsList = createAction('proposals/fetchAppraisalsList')
